import {
  FETCH_INVESTIGATORS_WORKLOAD,
  FETCH_INVESTIGATORS_WORKLOAD_SUCCESS,
  FETCH_INVESTIGATORS_WORKLOAD_FAIL
} from '../../actions/cm/investigators';

export const initialState = {
  list: [],
  isLoading: false,
  hasError: false,
  hasLoaded: false
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_INVESTIGATORS_WORKLOAD:
      return {
        ...state,
        isLoading: true,
        hasError: false
      };
    case FETCH_INVESTIGATORS_WORKLOAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasLoaded: true,
        list: payload || []
      };
    case FETCH_INVESTIGATORS_WORKLOAD_FAIL:
      return {
        ...state,
        isLoading: false,
        hasError: true
      };
    default:
      return state;
  }
}
